// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"F1-z","displaySixCardTiles":"G1-z"};